/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */
import { convertCoordinates } from './helpers'
function processCoordinates(addTo, values) {
  values.forEach(data => {
    console.log("Data", data)
    const { location, labelOffset, ...coords } = data
    addTo.locations[location].coordinates = convertCoordinates(coords)
    labelOffset && (addTo.locations[location].labelOffset = convertCoordinates(labelOffset))
    addTo.allLocations.push(location)
  })

  return addTo
}

export default processCoordinates
